import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cleave from 'cleave.js/react';

import { updateFilters } from '../../../../reducers/filtersSlice';

const BudgetInput = () => {
  const { collection: filtersCollection } = useSelector((state) => state.filters);
  const { budget, more_criteria } = filtersCollection
  const dispatch = useDispatch();

  const cleaveOptions = {
    numeral: true,
    numeralThousandsGroupStyle: 'thousand',
    delimiter: ' ',
    numeralDecimalScale: 0
  }

  const textInputs = [
    { inputName: 'min_budget', displayName: 'Budget minimum' },
    { inputName: 'max_budget', displayName: 'Budget maximum' }
  ]

  useEffect(() => {
    if (parseInt(budget.min_budget.replace(/ /g, ''), 10) >= 1500000 && !more_criteria.includes('display_sold')) {
      dispatch(updateFilters({
        ...filtersCollection,
        more_criteria: [...more_criteria, 'display_sold']
      }))
    }

  }, [budget.min_budget])

  const onChange = (e, inputName) => {
    if (e.target.value > e.target.value.substring(0, 12)) return;

    dispatch(
      updateFilters({
        ...filtersCollection,
        budget: { ...budget, [inputName]: e.target.value.substring(0, 12) }
      })
    );
  }

  return(
    <div className='vesta-w-full vesta-budget-inputs'>
      {textInputs.map(({ inputName, displayName }, index) => (
        <label key={index} className='typo-bold-content'>
          {displayName}
          <div className='vesta-currency-wrapper vesta-margin-y-10'>
            <Cleave
              placeholder='-'
              name={inputName}
              className={`vesta-input vesta-input--${inputName}`}
              pattern='[0-9]*'
              value={budget[inputName]}
              options={cleaveOptions}
              onChange={(e) => onChange(e, inputName)}
            />
            <span className='vesta-currency-code typo-content vesta-purple-50'>€</span>
          </div>
        </label>
      ))}
    </div>
  )
};

export default BudgetInput;
